import { render, staticRenderFns } from "./SelectMegaMenu.vue?vue&type=template&id=5f3ffd64"
import script from "./SelectMegaMenu.vue?vue&type=script&lang=js"
export * from "./SelectMegaMenu.vue?vue&type=script&lang=js"
import style0 from "./SelectMegaMenu.vue?vue&type=style&index=0&id=5f3ffd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports